export default __webpack_public_path__ + "static/media/6_active.904daf9c.png";